<template>
  <div class="MyBoardWrite">
    <!-- s: header -->
    <header id="header-slidePanel">
      <h2>작성글 보기</h2>
      <div class="btn_back">
        <a @click="slidePanelClose"><img src="@/assets/images/btn_close.png" width="50" alt="이전"/></a>
      </div>
    </header>
    <!-- e: header -->
    <div class="contents-area-slidePanel">
      <!-- profile-area -->
      <div class="profile-area">
        <div class="photo-area">
          <p class="ir" :style="'background-image: url('+oUser.strProfileImg+')'">
            사용자 이미지
          </p>
          <div class="nickname-area">
            <strong>{{ oUser.strNickName }}<span>님</span></strong>
            <span>{{ oUser.strUserId }}</span>
          </div>
        </div>
        <div class="board-block-area" v-if="blockCode != 'F'">
          <label>게시글 차단</label>
          <mt-switch v-model="strBlockCode" @change="memberBlock(nUserNum)"></mt-switch>
        </div>
      </div>
      <!-- // profile-area -->
      <div class="boardList clearfix mrg-top-20" v-infinite-scroll="getArticleBoardList"
           infinite-scroll-disabled="loading" infinite-scroll-distance="300">
        <ul>
          <li v-for="(data, index) in boardList"
              :key="index"
              @click="boardDetailMove(data.nMenuNum, data.nBoardNum, data.oAuthorizeAccessRead)"
          >
            <div class="infoBox">
              <div class="title clearfix">
                <a>{{ data.strTitle }}</a>
              </div>
              <div class="info">
                <span class="time">{{ data.strRegDate | moment("YY.MM.DD") }}</span>
              </div>
            </div>
            <div class="replyBox">
              <strong>{{ data.nReplyCnt }}</strong>
              <span>댓글</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="text-center mrg-top-20">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyBoardWrite',
  props: ['nUserNum'],
  data() {
    return {
      loading: false,          // 로딩여부
      listMore: true,          // infinite 종료여부
      page: 1,                 // 현재 페이지
      oUser: '',               // 회원 정보
      boardList: [],           // 게시글 저보
      blockCode: '',           // 차단 코드 (F :: 본인 (차단여부변경 불가), Y :: 차단 상태, N :: 미차단 상태)
      strBlockCode: false,     // 차단 여부
    }
  },
  // 감시자
  watch: {},
  // $el 생성전
  created() {
  },
  // $el 생성후
  mounted() {
    window.callbackBackKey = this.callbackBackKey;
    this.getArticleBoardList();
  },
  methods: {
    // APP 뒤로가기
    callbackBackKey() {
      this.slidePanelClose();
    },
    // 타인의 게시글 리스트
    getArticleBoardList() {
      if (this.listMore == false) {
        return false;
      }

      this.loading = true;
      let nPage = this.page++;
      let param = {};

      this.ajaxGetAuth('/api/v1/article/' + this.nUserNum + '/board/' + nPage, param, this.getArticleBoardListResult);
    },
    // 타인의 게시글 리스트 결과
    getArticleBoardListResult(response) {

      if (response.result.code == 0) {
        let vm = this;
        // 게시글 리스트
        response.oArticle.list.forEach(function (key) {
          vm.boardList.push(key)
        })
        this.oUser = response.oUser;
        if (response.oUser.oBlockInfo.strBlockCode == 'Y') {
          this.strBlockCode = true;
        } else if (response.oUser.oBlockInfo.strBlockCode == 'N') {
          this.strBlockCode = false;
        } else {
          this.strBlockCode = false;
        }

        this.blockCode = response.oUser.oBlockInfo.strBlockCode;

        // 현재 페이지와 마지막 페이지가 같은경우
        if (response.oArticle.setting.nNowPage == response.oArticle.setting.nMaxPage) {
          this.listMore = false;
        }

      } else {
        if (response.result.resultNoti.type == 'alert') {
          this.toastMsg(response.result.resultNoti.message, 1500)
        } else {
          this.errorMsg = response.result.resultNoti.message;
          this.errorField = response.result.resultNoti.validationFail.id;
        }
      }

      this.loading = false;
    },
  }
}
</script>

<style scoped>
.profile-area {
  padding: 15px 15px 25px;
  height: 66px;
  position: relative;
  background: #f5f8ff;
  margin: 0 -20px 0px -20px;
}

.profile-area .photo-area > p {
  margin-top: 2px;
  float: left;
  position: relative;
  display: inline-block;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  border-radius: 10px;
  overflow: hidden;
  background-image: url(../../assets/images/user-profile.png);
}

.profile-area .photo-area .nickname-area {
  float: left;
  margin-left: 10px;
}

.profile-area .photo-area .nickname-area > strong {
  display: block;
  overflow: hidden;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.profile-area .photo-area .nickname-area > strong > span {
  width: 20px;
  margin-left: 5px;
  font-weight: 300;
  font-size: 1rem;
}

.profile-area .photo-area .nickname-area > span {
  display: block;
  float: left;
  font-size: 14px;
}

.profile-area .board-block-area {
  position: absolute;
  bottom: 15px;
  left: 90px;
  margin-right: 10px;
}

.profile-area .board-block-area label {
  float: left;
  margin: 0 10px 0 5px;
  line-height: 33px;
  font-size: 14px;
}

.slidePanel-sub-title {
  border-bottom: 1px solid #efefef;
  margin-bottom: 20px;
  font-weight: 600;
  padding-bottom: 5px;
}
</style>
